import React from "react";
import SEO from "../common/SEO";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import FooterOne from "../common/footer/FooterOne";
import BannerFive from "../component/banner/BannerFive";
import HeaderFour from "../common/header/HeaderFour";
import SplashData from '../data/splash/SplashData.json';
import { Link } from 'react-router-dom';
import { slugify } from '../utils';


const CorporateAgency = () => {
  return (
    <>
      <SEO title="Schedule Appointment" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />
        <BannerFive />
        <FooterOne />
      </main>
    
    </>
  );
};

export default CorporateAgency;
